import React, { useRef } from "react";
import { useUploader } from "@utils";

export default function DesignSystemLogoUpload({ logoUrl, onLogoChange }) {
    const fileRef = useRef(null);

    const { uploadFiles, loading } = useUploader({
        isPublic: true,
        onFileUpload: ({ permanentUrl, key }) => {
            onLogoChange(permanentUrl || key);
        },
    });

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        uploadFiles([file]);
    };

    const handleRemove = () => {
        onLogoChange(null);
        if (fileRef.current) fileRef.current.value = "";
    };

    return (
        <div>
            <label className="text-sm font-medium">Company Logo</label>
            <div className="flex items-center gap-3 mt-1">
                <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/svg+xml" onChange={handleFileChange} className="hidden" />
                {logoUrl ? (
                    <img src={logoUrl} alt="Logo" className="h-10 w-10 object-contain rounded border border-input" />
                ) : (
                    <div className="h-10 w-10 rounded border border-dashed border-input flex items-center justify-center text-muted-foreground text-xs">Logo</div>
                )}
                <button type="button" onClick={() => fileRef.current?.click()} disabled={loading} className="px-3 py-1.5 text-sm border border-input rounded-md hover:bg-accent">
                    {loading ? "Uploading..." : logoUrl ? "Change" : "Upload"}
                </button>
                {logoUrl && (
                    <button type="button" onClick={handleRemove} className="px-3 py-1.5 text-sm text-destructive border border-input rounded-md hover:bg-destructive/10">
                        Remove
                    </button>
                )}
            </div>
            <p className="text-xs text-muted-foreground mt-1">Shown in generated applications</p>
        </div>
    );
}
